import { makeVar, useReactiveVar } from '@apollo/client';
import { useEffect } from 'react';
import { PersistedStateKeys } from 'shared/enums';
import usePersistedState from 'shared/hooks/usePersistedState';

const setAppointmentCalendarCurrentDay = makeVar(new Date());

const useAppointmentCalendarCurrentDay = (): { currentDay: Date; setCurrentDay: (d: Date) => void } => {
  const [persistedCurrentDay, setPersistedCurrentDay] = usePersistedState(
    PersistedStateKeys.AppointmentCalendarCurrentDay,
    new Date(),
    (key, value) => new Date(value),
  );

  const currentDay = useReactiveVar(setAppointmentCalendarCurrentDay);

  useEffect(() => {
    setPersistedCurrentDay(currentDay);
  }, [currentDay, setPersistedCurrentDay]);

  useEffect(() => {
    setAppointmentCalendarCurrentDay(persistedCurrentDay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { currentDay, setCurrentDay: setAppointmentCalendarCurrentDay };
};

export default useAppointmentCalendarCurrentDay;
